import React, { Fragment, useEffect, useState } from "react";
import "./SwapAdd.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  Divider,
  Badge,
  Tooltip,
  CircularProgress,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  add_product_action,
  remove_product_action,
  set_amount_product_action,
} from "../../../redux/actions/cart";

import {
  Remove as RemoveIcon,
  Add as AddIcon,
  SwapHoriz as SwapHorizIcon,
} from "@mui/icons-material";
import { API_URL, backend } from "../../../config";

const SwapAdd = (props) => {
  // type = 1 (button) type = 2 (icon)
  const { data, type = 1, display = false, handleCloseSubs } = props;
  const dispatch = useDispatch();

  const cartStore = useSelector((state) => state.cart);
  const customerStore = useSelector((state) => state.customer);

  const add = (swapItem) => {
    const swapItemObj = { ...swapItem, added_through_sub: true };

    dispatch(add_product_action(swapItemObj, customerStore, true));
  };

  const substract = (swapItem, cartItem) => {
    if (cartItem && cartItem.unit_in_cart > 0) {
      dispatch(remove_product_action(swapItem, customerStore, true));
    }
  };

  const addCase = (swapItem) => {
    const swapItemObj = { ...swapItem, added_through_sub: true };

    dispatch(add_product_action(swapItemObj, customerStore, false));
  };

  const substractCase = (swapItem, cartItem) => {
    if (cartItem && cartItem.case_in_cart > 0) {
      dispatch(remove_product_action(swapItem, customerStore, false));
    }
  };

  const handleAmountChange = (e, cartItem) => {
    const { name, value } = e.target;

    const amount = value === "" ? 0 : value;

    dispatch(
      set_amount_product_action(
        cartItem,
        customerStore,
        amount,
        name === "unit_in_cart",
      ),
    );
  };

  const [openSwapAddDialog, setOpenSwapAddDialog] = useState(false);
  const [swapOptions, setSwapOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseSwapAddDialog = () => {
    setOpenSwapAddDialog(false);
    handleCloseSubs();
  };

  const handleClickSwapAddDialog = () => setOpenSwapAddDialog(true);

  useEffect(() => {
    if (display) {
      setOpenSwapAddDialog(true);
    }
  }, [display]);

  useEffect(() => {
    const assignUpdateSwapOptions = async () => {
      if (
        data.acceptable_substitutions &&
        data.acceptable_substitutions.length
      ) {
        setIsLoading(true);
        const acceptableSubsUPCs = data.acceptable_substitutions.map(
          (asItem) => asItem.upc,
        );

        const productIdStr = acceptableSubsUPCs.join("&upc=");
        const companyLocationId = customerStore?.company_id;

        await backend
          .get(
            `${API_URL}products?no_page=1&company_location=${companyLocationId}&upc=${productIdStr}`,
          )
          .then((response) => {
            setSwapOptions(
              data.acceptable_substitutions.map((asItem) => {
                const productObj = response.data.find(
                  (item) => item.upc === asItem.upc,
                );

                const existingProductInCart = cartStore[customerStore?.id]
                  ?.products?.length
                  ? cartStore[customerStore.id].products.find(
                      (product) => product.upc === asItem.upc,
                    )
                  : undefined;

                return {
                  ...productObj,
                  asItem,
                  added_in_cart: existingProductInCart ? true : false,
                  added_through_sub: existingProductInCart
                    ? existingProductInCart.added_through_sub
                    : false,
                };
              }),
            );
            setIsLoading(false);
          });
      }
    };

    if (openSwapAddDialog) {
      assignUpdateSwapOptions();
    }
  }, [cartStore, customerStore, data, openSwapAddDialog]);

  return (
    <>
      {data.acceptable_substitutions && data.acceptable_substitutions.length ? (
        <>
          {type === 1 ? (
            <Badge
              badgeContent={
                data.acceptable_substitutions.filter((item) => {
                  const existingProductInCart = cartStore[customerStore?.id]
                    ?.products?.length
                    ? cartStore[customerStore.id].products.find(
                        (product) => product.upc === item.upc,
                      )
                    : undefined;

                  return (
                    existingProductInCart &&
                    existingProductInCart.added_through_sub
                  );
                }).length
              }
              color="primary"
            >
              <Button
                variant="contained"
                style={{ backgroundColor: "green" }}
                onClick={handleClickSwapAddDialog}
              >
                substitutions
              </Button>
            </Badge>
          ) : (
            <Tooltip title="Acceptable substitutions information">
              <IconButton onClick={handleClickSwapAddDialog}>
                <SwapHorizIcon color={"green"} />
              </IconButton>
            </Tooltip>
          )}
          <Dialog onClose={handleCloseSwapAddDialog} open={openSwapAddDialog}>
            <DialogTitle>Acceptable substitutions</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    <strong>{`${data.name}`}</strong>
                  </Typography>
                </Grid>
                {isLoading && (
                  <Grid item xs={12}>
                    <CircularProgress />
                    <Typography>Loading...</Typography>
                  </Grid>
                )}
                {!isLoading && swapOptions.length > 0 && (
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}></Grid>
                      {swapOptions.map((soItem, index) => {
                        const existingProductInCart = cartStore[
                          customerStore?.id
                        ]?.products?.length
                          ? cartStore[customerStore.id].products.find(
                              (product) => product.upc === soItem.upc,
                            )
                          : undefined;

                        return (
                          <Fragment key={`${data.upc}-as-${index}`}>
                            {Boolean(soItem?.item_code?.item_code) && (
                              <Grid item xs={12}>
                                <Typography>
                                  {soItem?.item_code?.item_code || ""}
                                </Typography>
                              </Grid>
                            )}
                            {Boolean(soItem?.name) && (
                              <Grid item xs={12}>
                                <Typography>{soItem?.name || ""}</Typography>
                              </Grid>
                            )}
                            {soItem?.display_unit_price > 0 ? (
                              <>
                                <Grid item xs={"auto"}>
                                  <Typography
                                    align="left"
                                    className="typographyPriceUnit"
                                    style={{ width: 200 }}
                                  >
                                    ${soItem.display_unit_price}
                                    <span style={{ fontWeight: 900 }}>
                                      {" "}
                                      UNIT
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <IconButton
                                    onClick={() =>
                                      substract(soItem, existingProductInCart)
                                    }
                                  >
                                    <RemoveIcon color="error" />
                                  </IconButton>
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    variant="standard"
                                    name="unit_in_cart"
                                    value={
                                      existingProductInCart
                                        ? existingProductInCart.unit_in_cart
                                        : 0
                                    }
                                    onChange={(e) =>
                                      handleAmountChange(e, soItem)
                                    }
                                    inputProps={{
                                      style: {
                                        textAlign: "center",
                                        maxWidth: 40,
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <IconButton onClick={() => add(soItem)}>
                                    <AddIcon color="success" />
                                  </IconButton>
                                </Grid>
                              </>
                            ) : (
                              <></>
                            )}
                            <Grid item xs={12}></Grid>
                            {soItem?.display_case_price > 0 ? (
                              <>
                                <Grid item xs={"auto"}>
                                  <Typography
                                    align="left"
                                    className="typographyPriceCase"
                                    style={{ width: 200 }}
                                  >
                                    ${soItem.display_case_price} (
                                    {soItem.units_per_case})
                                    <span style={{ fontWeight: 900 }}>
                                      {" "}
                                      CASE
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <IconButton
                                    onClick={() =>
                                      substractCase(
                                        soItem,
                                        existingProductInCart,
                                      )
                                    }
                                  >
                                    <RemoveIcon color="error" />
                                  </IconButton>
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <TextField
                                    size="small"
                                    variant="standard"
                                    name="case_in_cart"
                                    value={
                                      existingProductInCart
                                        ? existingProductInCart.case_in_cart
                                        : 0
                                    }
                                    onChange={(e) =>
                                      handleAmountChange(e, soItem)
                                    }
                                    inputProps={{
                                      style: {
                                        textAlign: "center",
                                        maxWidth: 40,
                                      },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <IconButton onClick={() => addCase(soItem)}>
                                    <AddIcon color="success" />
                                  </IconButton>
                                </Grid>
                              </>
                            ) : (
                              <></>
                            )}
                            {Boolean(soItem?.stock_level) && (
                              <Grid item xs={12}>
                                <Typography
                                  align="left"
                                  className="typographyInventory"
                                >
                                  {` Inventory Stock: `}
                                  <b>{`${soItem.stock_level || "N/A"}`}</b>
                                </Typography>
                              </Grid>
                            )}
                            {Boolean(soItem?.combined_stock_level) && (
                              <Grid item xs={12}>
                                <Typography
                                  align="left"
                                  className="typographyInventory"
                                >
                                  {` Combined Stock: `}
                                  <b>{`${soItem.combined_stock_level || "N/A"}`}</b>
                                </Typography>
                              </Grid>
                            )}
                            {Boolean(soItem?.upc) && (
                              <Grid item xs={12} style={{ marginTop: 8 }}>
                                <Divider />
                              </Grid>
                            )}
                          </Fragment>
                        );
                      })}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                color="error"
                variant="contained"
                onClick={handleCloseSwapAddDialog}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default SwapAdd;
